export default "__VITE_ASSET__wQhBsoW5__"